import types from './types';

const fetchData = () => ({
  type: types.FETCH_DATA,
});

const fetchSuccess = ({ data, graphData, meta }) => ({
  type: types.FETCH_SUCCESS,
  payload: { data, graphData, meta },
});

const fetchError = (error) => ({
  type: types.FETCH_ERROR,
  payload: { error },
});

const setParams = (params) => ({
  type: types.SET_PARAMS,
  payload: params,
});

const cleanState = () => ({
  type: types.CLEAN_STATE,
});

const downloadCsv = () => ({
  type: types.DOWNLOAD_CSV,
});

export default {
  fetchData,
  fetchSuccess,
  fetchError,
  setParams,
  cleanState,
  downloadCsv,
};
